import ManageProfiles from './ProfilesList'
import EditProfile from './EditProfile'
import PreviewProfile from './PreviewProfile'

export default [{
  path: '/manage/profiles',
  name: 'ManageProfiles',
  component: ManageProfiles,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Manage Profiles'}
}, {
  path: '/manage/profile/:id',
  name: 'PreviewProfile',
  component: PreviewProfile,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Edit Profile'}
}, {
  path: '/manage/profile/:id/edit',
  name: 'EditProfile',
  component: EditProfile,
  meta: {auth: true, bodyClass: 'light-skin fixed-navbar sidebar-scroll fixed-footer', title: 'Edit Profile'}
}]



// WEBPACK FOOTER //
// ./src/pages/manageProfiles/router.js